
export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePrivacyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/privacy');
    } else {
      window.location.href = '/privacy';
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{fontFamily: '"Pacifico", serif'}}>
              Fast Funding Capital
            </h3>
            <p className="text-gray-300 mb-4 max-w-md">
              Your trusted partner in commercial real estate financing. We connect investors and businesses with flexible funding solutions through our extensive lender network.
            </p>
            <div className="flex space-x-4">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </div>
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </div>
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors">
                <i className="ri-twitter-x-fill text-xl"></i>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/privacy" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/code-of-conduct" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Code of Conduct
                </a>
              </li>
              <li>
                <a href="/sms-opt-in" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  SMS Terms
                </a>
              </li>
              <li>
                <a href="/sms-opt-out" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  SMS Opt-Out
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-phone-fill text-blue-400"></i>
                </div>
                <span className="text-gray-300">346.291.8220</span>
              </div>
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-mail-fill text-blue-400"></i>
                </div>
                <span className="text-gray-300">info@fastfundingcap.com</span>
              </div>
              <div className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-1">
                  <i className="ri-map-pin-fill text-blue-400"></i>
                </div>
                <span className="text-gray-300">
                  2100 West Loop S Suite 800<br />
                  Houston, TX 77027
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © {currentYear} Fast Funding Capital. All rights reserved. | Licensed Real Estate Broker
          </p>
          <p className="text-gray-500 text-sm mt-2">
            Fast Funding Capital is a commercial real estate brokerage firm, not a direct lender. All loan products are subject to credit approval and property evaluation.
          </p>
        </div>
      </div>
    </footer>
  );
}
